<template>
    <div>
        <section>
            <div class="inner row5">
                <div class="title">
                    <h1>1:1 문의</h1>
                </div>
                <section>
                    <div class="row4">
                        <div class="bdTop">
                            <div class="mainContext">
                                <p> {{ contents }} </p>
                                <div class="flex">
                                    <div class="qnaSubscript">
                                        <span class="firstCon">작성자</span>
                                        <span class="secondCon">
                                            {{ WRITER }}
                                        </span>
                                    </div>
                                    <div class="qnaSubscript">
                                        <span class="firstCon">등록일</span>
                                        <span class="secondCon">
                                            {{ REGDATE }}
                                        </span>
                                    </div>
                                    <div class="qnaSubscript">
                                        <span class="firstCon">첨부파일</span>
                                        <span class="secondCon">
                                            <i><img src="../../assets/images/cmmnMain/첨부파일아이콘.png" alt=""></i>
                                            {{ FILENAME }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="questionBox">
                                <div class="questionTxtBox">
                                    <p>
                                        {{ questionContxt }}
                                    </p>
                                </div>
                            </div>
                            <div class="answerTitle flex flexAlignS">
                                <p>
                                    답변 :
                                </p>
                                <div>
                                    <div class="detailInputBox flex flexAlignC">
                                        <label>첨부파일</label>
                                        <div class="detailFileInputBox">
                                            <input class="upload-name" value="파일선택" disabled="disabled" >
                                            <label for="input-file">업로드</label>
                                            <input type="file" id="input-file" class="upload-hidden">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="answerBox">
                                <form action="">
                                    <textarea class="answerBoxItem" placeholder="답변을 입력해주세요."></textarea>
                                </form>
                            </div>
                            <div class="btnBox smTopPd">
                                <button @click="listBtnGo()" class="redborderBtn">취 소</button>
                                <button class="redBtn">수 정</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>   
</template>

<script>
export default {
    name: 'QNADetail',
    data() {
        return {
            contents: '문의를 하고 싶습니다. 오늘의 저녁 메뉴는 무엇인가요?',
            WRITER: '작성자',
            REGDATE: '2020.06.04',
            FILENAME: '기타문서.pdf',
            questionContxt: '저는 탕수육이 먹고 싶은데요? 왜 다들 깐풍기를 먹으라고 하는 건가요???',
            answerContxt: '그럼 양장피를 드세요.',
            totalNo: 1,
            nowPage: 1,
            totalPage: 2,
            perPage: 4,
            currentPage: 1,
            totalCnt: 0,
            // sample items
            items: [
                {
                    ID: '1',
                    Title: '문의드립니다. 사과는 빨간색 입니까?  검은색 입니까?',
                    NAME: '작성자',
                    Regdate: '2021.06.04',
                    ANSWERSTATUS: '답변대기',
                },
                {
                    ID: '2',
                    Title: '문의드립니다. 사과는 빨간색 입니까?  검은색 입니까?',
                    NAME: '작성자',
                    Regdate: '2021.06.04',
                    ANSWERSTATUS: '답변완료',
                }
            ],
            //sortBy: 최초 보이는 화면의 sort 기준, sortDesc 순서
            sortBy: 'ID',
            sortDesc: false,
            fields: [
                {
                    key: 'ID',
                    label: 'NO.',
                    sortable: false,
                    sortDirection: 'desc'
                },
                {
                    key: 'Title',
                    label: '제목',
                    sortable: false
                },
                {
                    key: 'NAME',
                    label: '작성자',
                    sortable: false
                },
                {
                    key: 'Regdate',
                    label: '등록일',
                    sortable: false
                },
                {
                    key: 'ANSWERSTATUS',
                    label: '문의상태',
                    sortable: false
                }
            ]
        }
    },
    methods:{
        goback(){
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
    }
</style>

<style scoped>
    .mainContext {
        margin: 0 0 30px 0;
    }
    .bdTop {
        border-top: 2px solid #949494;
        padding: 30px 0 0;
    }
    .mainContext p {
        margin: 0 0 18px 0;
    }
    .qnaSubscript {
        margin: 0 50px 0 0;
    }
    .qnaSubscript span {
        font-size: 24px;
        line-height: 35px;
    }
    .qnaSubscript span:first-child {
        margin: 0 10px 0 0;
    }
    .firstCon {
        color: #272727;
    }
    .secondCon {
        color: #777777;
    }
    .secondCon i {
        vertical-align: middle;
    }
    .questionBox {
        border: 1px solid #E7E7E7;
        padding: 20px 30px;
        min-height: 260px;
    }
    .questionTxtBox {
        overflow: auto;
    }
    .answerTitle {
        padding: 10px 0 10px 30px;
    }
    .answerBox {
        border: 1px solid #E7E7E7;
        background: #FDFCFC;
        padding: 20px 30px;
        min-height: 260px;
    }
    .answerTxtBox {
        overflow: auto;
    }
    .answerTitle .detailInputBox {
        padding: 0;
    }
    .answerBoxItem {
        width: 100%;
        min-height: 220px;
        resize: none;
        border: 0;
        background: transparent;
        font-size: 24px;
        line-height: 35px;
        color: #272727;
        resize: none;
        font-family: "NotoSans";
    }
    .answerBoxItem:focus {
        outline: none;
    }
    .subBtnContain {
    padding: 10px 20px 0 30px;
    }
    .subBtnContain a {
        font-size: 24px;
        line-height: 35px;
        color: #272727;
    }
    .prevNextBtnContain a {
        margin: 0 0 0 40px;
    }
</style>